import { render, staticRenderFns } from "./68qgpdldzj.vue?vue&type=template&id=85093bba&"
import script from "./68qgpdldzj.vue?vue&type=script&lang=js&"
export * from "./68qgpdldzj.vue?vue&type=script&lang=js&"
import style0 from "./68qgpdldzj.vue?vue&type=style&index=0&id=85093bba&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports